export default "__VITE_ASSET__CvOcSdCv__"